import { Col, Row } from "antd";
import React from "react";

export default function PageTitle(props) {
  const { pageTitle, pageText } = props;

  return (
    <Col span={24}>
      <Row>
        <Col span={24}>
          {pageTitle && <h4 className="hp-mb-8"><b>{pageTitle}</b></h4>}
        </Col>
        <Col span={24}>
          {pageText && <p className="hp-mb-0 hp-p1-body">{pageText}</p>}
        </Col>
      </Row>
    </Col>
  );
}
